<template>
<div>
  <AppTextField v-model.trim="model.$model"
                :label="$t('common.identity-checking.form-fields.LastName.usageLastName')"
                :error-messages="lastNameErrors"
                :error="isErrored"
  >
    <template #append-inner>
      <AppTooltip location="bottom" max-width="300">
        <template v-slot:activator="{ props }">
          <app-material-icon name="help"
                             class="clickable mr-2"
                             v-bind="props"
          />
        </template>
        <span>{{ $t("common.identity-checking.form-fields.LastName.usageLastNameExample") }}</span>
      </AppTooltip>
    </template>
  </AppTextField>

  <AppTextFieldSuggestion v-if="displaySuggestedValue"
                          :suggestedValue="suggestedValue"
                          @validate="model.$model = suggestedValue"
  />
</div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

import AppTextField from '@/common/AppTextField.vue'
import AppTooltip from '@/common/AppTooltip.vue'
import AppTextFieldSuggestion from '@/common/identity-checking/AppTextFieldSuggestion.vue'
import { formFieldErrors } from '@/common/utils/form'
import { ID_CHECK_ERRORS } from '@/common/utils/idCheckErrors'

export default {
  name: 'LastName',
  components: { AppTextField, AppTextFieldSuggestion, AppTooltip },
  props: {
    model: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState('user', ['idCheckError']),
    ...mapGetters('user', ['hasIdCheckErrorInfo']),
    lastNameErrors () {
      return formFieldErrors(
          this.model,
          [
            ['required', this.$t('common.validations.fieldRequired', { fieldName: this.$t('common.identity-checking.form-fields.LastName.usageLastName') })],
          ],
      )
    },
    isErrored () {
      return this.hasIdCheckErrorInfo &&
        this.idCheckError.errors.includes(ID_CHECK_ERRORS.ERROR_BIRTHNAME_MISMATCH) &&
        this.displaySuggestedValue
    },
    suggestedValue () {
      return this.idCheckError?.suggestedValues?.lastName
    },
    displaySuggestedValue () {
      return this.suggestedValue && this.suggestedValue !== this.model.$model
    },
  },
}
</script>
